import { render, staticRenderFns } from "./RentTariffsViewTable.vue?vue&type=template&id=029ba8c2&lang=pug&"
import script from "./RentTariffsViewTable.vue?vue&type=script&lang=js&"
export * from "./RentTariffsViewTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports